import API from "./api";

const privateExamApi = {
  getMyExams: () => API.get("/private-exams/my"),
  getExamById: (id) => API.get(`/private-exams/${id}`),
  startExam: (id) => API.post(`/private-exams/${id}/start`),
  submitExam: (id, payload) => API.post(`/private-exams/${id}/submit`, payload),
};

export default privateExamApi;
